import type { ReactNode } from "react"

export type ProductStatusVariant = "ready" | "needSetup" | "processing"

const statusDotClassNameByVariant: Record<ProductStatusVariant, string> = {
  ready: "bg-status-ready",
  needSetup: "bg-status-idle",
  processing: "animate-pulse bg-vto-accent/40",
}

interface ProductStatusBadgeProps {
  children: ReactNode
  variant: ProductStatusVariant
}

export const ProductStatusBadge = ({ children, variant }: ProductStatusBadgeProps) => (
  <span className="inline-flex items-center gap-2 text-sm font-medium text-foreground">
    <span className={`size-2.5 shrink-0 rounded-full ${statusDotClassNameByVariant[variant]}`} />
    <span className="whitespace-nowrap">{children}</span>
  </span>
)
